import {Link, Route} from 'react-router-dom';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import {useSelector} from "react-redux";
import {checkPermission} from "./RouteValidator";
import UnitManagement from "../../modules/product/UnitManagement";
import AddUnit from "../../modules/product/AddUnit";
import UpdateUnit from "../../modules/product/UpdateUnit";
import CategoryManagement from "../../modules/product/CategoryManagement";
import AddCategory from "../../modules/product/AddCategory";
import UpdateCategory from "../../modules/product/UpdateCategory";
import ProductManagement from "../../modules/product/ProductManagement";
import AddProduct from "../../modules/product/AddProduct";
import UpdateProduct from "../../modules/product/UpdateProduct";
import InventoryManagement from "../../modules/inventory/InventoryManagement";

const GenerateInventoryModuleRoutes = () => {
    const company = useSelector((state: any) => state.company);
    const auth = useSelector((state: any) => state.auth);

    const routes: any = [];

    if (checkPermission(auth, company, '/units')) {
        routes.push(
            <Route path={'/units'} element={
                <AuthMiddleware children={<UnitManagement/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/units/add')) {
        routes.push(
            <Route path={'/units/add'} element={
                <AuthMiddleware children={<AddUnit/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/units/details/id')) {
        routes.push(
            <Route path={'/units/details/:id'} element={
                <AuthMiddleware children={<UpdateUnit/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/categories')) {
        routes.push(
            <Route path={'/categories'} element={
                <AuthMiddleware children={<CategoryManagement/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/categories/add')) {
        routes.push(
            <Route path={'/categories/add'} element={
                <AuthMiddleware children={<AddCategory/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/categories/details/id')) {
        routes.push(
            <Route path={'/categories/details/:id'} element={
                <AuthMiddleware children={<UpdateCategory/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/products')) {
        routes.push(
            <Route path={'/products'} element={
                <AuthMiddleware children={<ProductManagement/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/products/add')) {
        routes.push(
            <Route path={'/products/add'} element={
                <AuthMiddleware children={<AddProduct/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/products/details/id')) {
        routes.push(
            <Route path={'/products/details/:id'} element={
                <AuthMiddleware children={<UpdateProduct/>}/>
            }/>
        );
    }

    routes.push(
        <Route path={'/inventory'} element={
            <AuthMiddleware children={<InventoryManagement/>}/>
        }/>
    );

    return routes;
}

export default GenerateInventoryModuleRoutes;
